var map = {
	"./ai_demo": 16810,
	"./ai_demo.json": 16810,
	"./dxc_model_categories": 9731,
	"./dxc_model_categories.json": 9731,
	"./dxc_model_categories_new": 39882,
	"./dxc_model_categories_new.json": 39882,
	"./elastic_nlp": 46017,
	"./elastic_nlp.json": 46017,
	"./ml_demo_britishvolt": 62637,
	"./ml_demo_britishvolt.json": 62637,
	"./ml_demo_zurich": 38968,
	"./ml_demo_zurich.json": 38968,
	"./ml_results": 75207,
	"./ml_results.json": 75207,
	"./ml_results_NEW": 45213,
	"./ml_results_NEW.json": 45213,
	"./watson_discovery": 18103,
	"./watson_discovery.json": 18103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57394;